<template>
  <div class="overflow-hidden">
    <m-modal-spinner v-if="spinner"></m-modal-spinner>
    <div class="position-relative w-100">
      <div class="position-absolute" style="z-index: 2000; top: 10px; right: 10px">
        <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon" @click="finish"
          style="width: 30px; height: 30px; min-height: 0">
          <icon width="20" height="20" name="times"></icon>
        </div>
        <div @click="help" class="mt-3 aide pointer color-white d-flex flex-row align-items-left justify-content-start"
          style="background-color:white; border-radius: 50%;">
          <icon width="30" height="30" name="question-circle" class="" color="#a2acbf"></icon>
        </div>
      </div>
    </div>
    <!-- <euros-header ref="header" titre="Alignez la bille rouge avec celle de la radio"
      pathRetour="/patients"></euros-header> -->
    <div class="container-fluid bg-blue">
      <div class="main3parts d-flex" ref="main3parts" style="">
        <div class="main3parts-col1 d-none d-lg-block" style="flex-grow: 0">
          <div>
            <img style="width: 120px" class="img-fluid d-none d-lg-block" src="/images/logo-euros-2025.png" alt="" />
          </div>
          <div class="mt-3">
            <button class="btn btn-primary w-100" @click="loadCircle()">Trouver la bille auto.</button><br />
            <button class="btn btn-primary btn-green w-100" @click="nextCircle()" v-if="circles.length">Bille
              Suivante</button>
          </div>
          <div class="mt-3 text-center">Aide : taper + ou - pour zoomer</div>
        </div>
        <div class="main3parts-col2 relative bg-dark" ref="gestoparent" style="flex-grow: 1">
          <div class="btn-next-page" @click="nextStep">
            <img src="/images/btn-gauss-droite.png" alt="" />
          </div>
          <!-- <div class="trouver-bille-mobile d-block d-lg-none">
            <div class="d-flex mt-3">
              <button class="btn btn-primary ml-3" @click="loadCircle()">Trouver la bille</button><br />
              <button class="btn btn-primary btn-green ml-2 d-flex align-items-center" @click="nextCircle()"
                v-if="circles.length">
                <icon width="20" height="20" name="forward"></icon>
              </button>
            </div>
          </div> -->
          <div
            v-if="patient.pa_toolstype == 'ruler' && (patient.pa_toolsrulersize == 'horizontal10' || patient.pa_toolsrulersize == 'horizontal20')"
            class="ruler-rouge-h" ref="ruler"></div>
          <div
            v-if="patient.pa_toolstype == 'ruler' && (patient.pa_toolsrulersize == 'vertical10' || patient.pa_toolsrulersize == 'vertical20')"
            class="ruler-rouge-v" ref="ruler"></div>
          <div v-if="patient.pa_toolstype == 'ball'" class="bille-rouge" ref="bille"></div>
          <div style="height: 100%; position: relative" ref="gesto">
            <div style="position: absolute" ref="bgimage">
              <img ref="imgRadio" class=""
                :src="$config.server_url + '/api/1.0/files/patient/' + $route.params.id + '?token=' + $store.state.accesstoken + '&origin=webapp'"
                alt="test" @load="imageLoaded" />
            </div>
          </div>
        </div>
        <div class="main3parts-col3 flex-column d-none d-lg-flex">
          <div class="" style="flex-grow: 1">
            <div v-if="patient.pa_toolstype == 'ball'" class="">
              <m-form-text type="number" label="Taille de la bille en mm"
                v-model="patient.pa_toolsballsize"></m-form-text>
            </div>
          </div>
          <div class="text-right" style="flex-grow: 0">
            <button @click="nextStep" class="btn btn-primary w-100" style="">Suivant</button>
          </div>
        </div>
        <div class="part3-mobile d-flex flex-column d-block d-lg-none">
          <!-- <div @click="showOrhideMenu" class="btn-menu-mobile" ref="btnMenuMobile">
            <icon :name="isShowMenu ? 'chevron-right' : 'chevron-left'" width="15" height="15"></icon>
          </div> -->
          <div ref="menuMobile" class="menuMobile text-center">
            <div class="barreduce-container" @click="showOrhideMenu">
              <div class="barreduce"></div>
            </div>
            <h5>CALIBRATION</h5>
            <div class="mb-3 text-center">
              <button class="btn btn-primary" @click="loadCircle()">Trouver la bille automatiquement</button>
              <button class="btn btn-primary btn-green mt-2" @click="nextCircle()" v-if="circles.length">
                Bille Suivante&nbsp;&nbsp;<icon width="20" height="20" name="forward"></icon>
              </button>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <div v-if="patient.pa_toolstype == 'ball'" class="d-flex">
                <div class="mr-1">Taille de la bille</div>
                <div class="mr-1" style="width: 50px">
                  <m-form-text type="number" label="" v-model="patient.pa_toolsballsize"></m-form-text>
                </div>
                <div class="mr-3">mm</div>
                <div class="mr-2 rounded-circle btn btn-primary d-flex align-items-center justify-content-center calibration-ball-size-btn"
                  @click="patient.pa_toolsballsize += 1" style="width: 30px; height: 30px; min-height: 0">
                  <span class="calibration-ball-size-icon" style="top: calc(50% - 2px)">
                    <icon width="20" height="20" name="chevron-up"></icon>
                  </span>
                </div>
                <div class="rounded-circle btn btn-primary d-flex align-items-center justify-content-center calibration-ball-size-btn"
                  @click="patient.pa_toolsballsize > 0 ? patient.pa_toolsballsize -= 1 : null"
                  style="width: 30px; height: 30px; min-height: 0">
                  <span class="calibration-ball-size-icon">
                    <icon width="20" height="20" name="chevron-down"></icon>
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <div class="mr-3">Côté</div>
              <div class="tabber">
                <label class="label-lateralite label-G ml-2" for="lateralitegc">Gauche</label>
                <input type="radio" v-model="patient.pa_lateralite" name="lateralitec" id="lateralitegc" value="left"
                  @change="drawElements" />
                <label class="label-lateralite label-D ml-4" for="lateralitedc">Droite</label>
                <input type="radio" v-model="patient.pa_lateralite" name="lateralitec" id="lateralitedc" value="right"
                  @change="drawElements" />
                <div class="blob"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="winmodal" v-if="$store.state.help.ratio"></div>
    <div class="helpwin" v-if="$store.state.help.ratio">
      <div class="winclose">
        <label for="notdisplayanymore" style="margin: -5px 30px"><input type="checkbox" id="notdisplayanymore"
            v-model="notdisplayanymore" />Ne plus afficher</label>
        <a href="javascript:void(0);" @click="$store.commit('set_help', ['ratio'])">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div v-if="help1">
            <h3>Méthode 1 : cliquez sur le bouton Trouver la bille automatiquement puis plusieurs fois sur le bouton
              Suivant.</h3>
            <p>Le programme essaye de trouver une forme circulaire dans l’image que vous venez d’envoyer</p>
            <p class="color-red">Puis saisissez la taille de la bille en mm</p>
            <div>
              <button class="btn btn-secondary" @click="clickHelp1">VOIR LA MÉTHODE 2</button>
            </div>
          </div>
          <div v-if="help2">
            <h3>Méthode 2 : Utilisez votre sourie pour positionner la bille sur votre radio avec la forme rouge au
              centre de l’écran.</h3>
            <p>Vous pouvez utiliser la sourie :</p>
            <ul>
              <li>Cliquer-glisser pour déplacer</li>
              <li>La molette de la sourie pour zoomer</li>
            </ul>
            <p>Mais aussi le clavier :</p>
            <ul>
              <li>Les touches + et - pour zoomer</li>
              <li>Les touches fléches haut, bas, droite et gauche pour vous déplacer</li>
            </ul>
            <p class="color-red">Puis saisissez la taille de la bille en mm</p>
            <div>
              <button class="btn btn-secondary" @click="clickHelp2">VOIR LA MÉTHODE 1</button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <img src="/images/aide/03-trouver-bille.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Moveable from "moveable";
// import Gesto from "gesto";
// import InfiniteViewer from "infinite-viewer";
import Hammer from "hammerjs";

export default {
  name: "ratio",
  components: {},
  props: {},
  data() {
    return {
      notdisplayanymore: false,
      help1: true,
      help2: false,
      spinner: true,
      circles: [],
      scaleStart: -1,
      file: {},
      patient: { pa_toolstype: "ball", pa_toolsballsize: "8", pa_toolsrulersize: "vertical10", pa_toolsscale: 0 },
      bgimage: {},
      getso: {},
      style: "",
      backgroundRadio: "",
      imageRatio: 1.96,
      tx: 0,
      ty: 0,
      scale: 1,
      isShowMenu: true,
      circleCenterX: 0,
      circleCenterY: 0,
      circleRayon: 0
      // moveable: {
      //   draggable: true,
      //   throttleDrag: 0,
      //   resizable: true,
      //   throttleResize: 1,
      //   keepRatio: true,
      //   scalable: false,
      //   throttleScale: 0,
      //   rotatable: true,
      //   throttleRotate: 0,
      //   pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
      //   origin: false
      // }
    };
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.onkeyup);
    window.removeEventListener("resize", this.setWindowHeight);
    window.removeEventListener("gesturestart", this.preventDefaultPerso);
    window.removeEventListener("gesturechange", this.preventDefaultPerso);
    window.removeEventListener("gestureend", this.preventDefaultPerso);
    window.removeEventListener("wheel", this.preventDefaultPerso, { passive: false });
  },
  async mounted() {
    this.setWindowHeight();
    // console.log("w", w);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    window.addEventListener("keyup", this.onkeyup);
    window.addEventListener("resize", this.setWindowHeight);
    window.addEventListener("gesturestart", this.preventDefaultPerso);
    window.addEventListener("gesturechange", this.preventDefaultPerso);
    window.addEventListener("gestureend", this.preventDefaultPerso);
    window.addEventListener("wheel", this.preventDefaultPerso, { passive: false });
    this.loadPatient();

    this.$refs.bgimage.addEventListener("mousedown", this.preventDefaultPerso);
    // this.$refs.imgRadio.addEventListener("mousedown", this.preventDefaultPerso);

    // let target2 = this.$refs.gesto;
    let clickPosX = 0,
      clickPosY = 0;
    let startMoveGesto = false;
    this.addMultipleEventsListener(this.$refs.gestoparent, "mousedown touchstart", e => {
      // console.log("mousedown", e);
      if (e.type == "touchstart") e = e.touches[0];
      startMoveGesto = true;
      clickPosX = e.clientX;
      clickPosY = e.clientY;
      // console.log("clickPosX,clickPosY", clickPosX, clickPosY);
    });
    this.addMultipleEventsListener(window, "mouseup touchend", e => {
      // console.log("mouseup");
      startMoveGesto = false;
    });
    this.addMultipleEventsListener(this.$refs.gestoparent, "mousemove touchmove", e => {
      //  console.log("e.deltaX", e);
      if (e.type == "touchmove") e = e.touches[0];
      if (startMoveGesto) {
        // let wContainer = this.$refs.gestoparent.offsetWidth,
        //   hContainer = this.$refs.gestoparent.offsetHeight;
        this.tx += (e.clientX - clickPosX) * (1 / this.scale);
        this.ty += (e.clientY - clickPosY) * (1 / this.scale);
        clickPosX = e.clientX;
        clickPosY = e.clientY;
        // toW = wContainer / 2 - this.tx;
        // toH = hContainer / 2 - this.ty;
        // console.log("mousemove", startMoveGesto, tx, ty, scale);
        // console.log("this.$refs.gesto.style.transform", this.$refs.gesto.style.transform);
        this.drawElements();
      }
    });

    let onzoom = e => {
      // console.log("e", e.scale, e.deltaY);
      // let previousScale = scale;
      if (e.scale) this.scale = this.scaleStart + e.scale - 1;
      else this.scale -= e.deltaY / 800;
      if (this.scale < 0.01) this.scale = 0.01;
      // console.log("scale, e.deltaX", scale, scale - previousScale);
      // this.$refs.gesto.style.transformOrigin = `${toW}px ${toH}px`;
      // this.$refs.gesto.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
      this.drawElements();
      e.preventDefault();
    };
    this.$refs.gestoparent.addEventListener("wheel", onzoom);
    var hammertime = new Hammer(this.$refs.gestoparent, {});
    hammertime.get("pinch").set({ enable: true });
    hammertime.on("pinch", onzoom);
    hammertime.on("pinchstart", () => {
      this.scaleStart = this.scale;
    });
    // hammertime.on("pinchend", () => {});

    // pour récupérer la hauteur de l'élément formulaire pour mobile et placer le chevron ouvrir/fermer
    // this.$nextTick(() => {
    //   if (this.$refs.menuMobile) {
    //     let height = this.$refs.menuMobile.clientHeight;
    //     if (height > 0) {
    //       let heightString = height + "px";
    //       this.$refs.btnMenuMobile.style.bottom = heightString;
    //     }
    //   }
    // });
  },
  // watch: {
  //   scale: function() {
  //     // console.log("scale", this.scale);
  //     this.calculatePixelInMm();
  //   }
  // },
  computed: {},
  methods: {
    clickHelp1() {
      this.help1 = false;
      this.help2 = true;
    },
    clickHelp2() {
      this.help1 = true;
      this.help2 = false;
    },
    clickHelp() {
      this.$store.commit("set_help", "ratio");
    },
    setWindowHeight() {
      // this.$refs.main3parts.style.minHeight = document.documentElement.clientHeight - this.$refs.header.$refs.header.offsetHeight + "px";
      this.$refs.main3parts.style.minHeight = document.documentElement.clientHeight + "px";
    },
    showOrhideMenu() {
      // let wContainer = this.$refs.menuMobile.offsetWidth + 15;
      let hContainer = this.$refs.menuMobile.offsetHeight - 30;
      if (this.isShowMenu) {
        this.$refs.menuMobile.style.transform = `translate(0, ${hContainer * 1}px)`;
      } else {
        this.$refs.menuMobile.style.transform = `translate(0, 0)`;
      }
      this.isShowMenu = !this.isShowMenu;
    },
    preventDefaultPerso(e) {
      e.preventDefault();
    },
    drawElements() {
      let wContainer = this.$refs.gestoparent.offsetWidth,
        hContainer = this.$refs.gestoparent.offsetHeight;
      // console.log("tx,ty", this.tx, this.ty);
      let toW = wContainer / 2 - this.tx;
      let toH = hContainer / 2 - this.ty;
      // this.scale = 1;
      this.$refs.gesto.style.transformOrigin = `${toW}px ${toH}px`;
      this.$refs.gesto.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
    },
    async loadCircle() {
      // wImage = this.$refs.bgimage.offsetWidth;
      // hImage = this.$refs.bgimage.offsetHeight;
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients/" + this.patient.pa_id + "/circle");
      // La requête peut se terminer après un changement de vue.
      if (!this.$refs.gestoparent) return;
      let data = response.data.data;
      // console.log("data", data);
      this.circles = data;
      if (!data.length) {
        alert("Aucune bille trouvée sur l'image");
        return;
      }
      this.currentCircle = 100000;
      this.nextCircle();
      //this.patient = response.data.data;
    },
    nextCircle() {
      const gestoParent = this.$refs.gestoparent;
      if (!gestoParent || !this.circles.length) return;

      let wContainer = gestoParent.offsetWidth,
        hContainer = gestoParent.offsetHeight;
      this.currentCircle++;
      if (this.currentCircle >= this.circles.length) this.currentCircle = 0;
      this.tx = this.circles[this.currentCircle].x * -1 + wContainer / 2;
      this.ty = this.circles[this.currentCircle].y * -1 + hContainer / 2;
      this.scale = 100 / (this.circles[this.currentCircle].r * 2);
      // console.log("this.scale", this.scale, wImage);
      // this.scale = 1;
      this.drawElements();
    },
    centerBgImage() {
      // console.log("center");
      let wContainer = this.$refs.gestoparent.offsetWidth,
        hContainer = this.$refs.gestoparent.offsetHeight,
        wImage = this.$refs.bgimage.offsetWidth,
        hImage = this.$refs.bgimage.offsetHeight;
      if (wContainer / wImage > hContainer / hImage) {
        this.scale = wContainer / wImage;
        this.ty = (hContainer - hImage) / 2;
        this.tx = (wImage * this.scale - wImage) / 2;
      } else {
        this.scale = hContainer / hImage;
        this.tx = (wContainer - wImage) / 2;
        this.ty = (hImage * this.scale - hImage) / 2;
      }
      // console.log("this.tx", this.tx, wContainer, wImage, (wContainer - hContainer) / 2);
      // let toW = wContainer / 2 - this.tx;
      // let toH = hContainer / 2 - this.ty;
      // this.$refs.gesto.style.transformOrigin = `${toW}px ${toH}px`;
      // this.$refs.gesto.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
      this.drawElements();
      // this.calculatePixelInMm();
    },
    absorbEvent_(event) {
      var e = event || window.event;
      e.preventDefault && e.preventDefault();
      // e.stopPropagation && e.stopPropagation();
      // e.cancelBubble = true;
      // e.returnValue = false;
      return true;
    },
    imageLoaded(e) {
      this.$refs.imgRadio.ontouchstart = this.absorbEvent_;
      this.$refs.imgRadio.ontouchmove = this.absorbEvent_;
      this.$refs.imgRadio.ontouchend = this.absorbEvent_;
      this.$refs.imgRadio.ontouchcancel = this.absorbEvent_;

      this.$nextTick(() => {
        this.drawElements();
        // this.centerBgImage();
        if (this.patient && !this.patient.pa_toolsscale) this.centerBgImage();
        this.spinner = false;
        // console.warn("image loaded");
      });
    },
    addMultipleEventsListener(el, s, fn) {
      s.split(" ").forEach(e => el.addEventListener(e, fn, false));
    },
    async loadPatient() {
      // load patient pour récupérer les pa_tools
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients/" + this.$route.params.id);
      this.patient = response.data.data;
      if (!this.patient.pa_toolstype) this.patient.pa_toolstype = "ball";
      if (!this.patient.pa_toolsballsize) {
        this.patient.pa_toolsballsize = this.patient.co_id.co_ballsize ? this.patient.co_id.co_ballsize : "8";
      }
      if (!this.patient.pa_toolsrulersize) this.patient.pa_toolsrulersize = "vertical10";
      if (!this.patient.pa_lateralite) this.patient.pa_lateralite = "";
      if (this.patient.pa_toolstx) this.tx = this.patient.pa_toolstx;
      if (this.patient.pa_toolsty) this.ty = this.patient.pa_toolsty;
      if (this.patient.pa_toolsscale) this.scale = this.patient.pa_toolsscale;
      this.drawElements();
      // console.log("this.patient.pa_toolsscale", this.patient.pa_toolsscale);
      if (!this.patient.pa_toolsscale) this.centerBgImage();
    },

    /************** les événements au clavier ***********   */
    onkeyup(event) {
      // console.log("onkeyup", event.key);
      if (event.key == "ArrowLeft") this.tx += -1;
      if (event.key == "ArrowRight") this.tx += 1;
      if (event.key == "ArrowUp") this.ty += -1;
      if (event.key == "ArrowDown") this.ty += 1;
      if (event.key == "+") this.scale += 0.1;
      if (event.key == "-") this.scale += -0.1;
      this.drawElements();
    },

    async nextStep() {
      if (!this.patient.pa_lateralite) {
        alert("Veuillez saisir le côté gauche / droite");
        return;
      }
      if (!this.patient.pa_toolsballsize) {
        alert("Veuillez saisir la taille de la bille en mm");
        return;
      }
      //on enregistre les pa_tools
      let dataPaTools = {
        pa_toolsballsize: this.patient.pa_toolsballsize,
        pa_toolstype: this.patient.pa_toolstype,
        pa_toolsrulersize: this.patient.pa_toolsrulersize,
        pa_toolsscale: this.scale,
        pa_toolstx: this.tx,
        pa_toolsty: this.ty,
        pa_lateralite: this.patient.pa_lateralite
      };
      await this.$axios.put(this.$config.server_url + "/api/1.0/patients/" + this.$route.params.id, dataPaTools);

      this.$router.push("/prosthesis/" + this.$route.params.id + "/1").catch(err => {});
    },

    async finish() {
      this.$router.push("/patients").catch(err => {});
    },
    help() {
      window.open(this.$config.server_url + "/api/1.0/files/help" + "?token=" + this.$store.state.accesstoken + "&origin=webapp", "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
.bille-rouge {
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  background-color: #ff000052;
  z-index: 1000;
}

.ruler-rouge-v {
  position: absolute;
  width: 10px;
  height: 100px;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  background-color: #ff000052;
  z-index: 1000;
}

.ruler-rouge-h {
  position: absolute;
  width: 100px;
  height: 10px;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  background-color: #ff000052;
  z-index: 1000;
}

.trouver-bille-mobile {
  position: absolute;
  //background-color: #353a4066;
  color: white;
  width: 100%;
  z-index: 1000;
  transition: transform 0.5s ease-out;
}

// .container-img-radio {
//   overflow: hidden;
// }
.main3parts {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 -15px;
  margin-top: 0;

  .main3parts-col1 {
    padding: 15px;

    .main3parts-col1-icos {
      flex-direction: row;

      .icos2 {
        margin-left: 30px;
      }
    }
  }

  .main3parts-col2 {
    overflow: hidden;
  }

  .main3parts-col3 {
    padding: 15px;
  }
}

.ico-move1 {
  width: 38px;
}

.ico-move2 {
  width: 15px;
}

.ico-move3 {
  width: 25px;
}

.ico-move4 {
  width: 15px;
}

@media (min-width: 576px) {
  .main3parts {
    margin-top: 40px;
    flex-direction: row;

    .main3parts-col1,
    .main3parts-col3 {
      min-width: 20%;
      margin: 0;
    }

    .main3parts-col2 {
      min-width: 60%;
      margin: 0;
    }

    .main3parts-col1 {
      .main3parts-col1-icos {
        flex-direction: column;

        .icos2 {
          margin-left: 0;
          margin-top: 30px;
        }
      }
    }
  }

  .ico-move1 {
    width: 50px;
  }

  .ico-move2 {
    width: 25px;
  }

  .ico-move3 {
    width: 35px;
  }

  .ico-move4 {
    width: 25px;
  }
}

/*************** css switch droite / gauche **************** */

.tabber {
  cursor: pointer;
  width: 230px;
  height: 28px;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background-color: #c3c9d4;
  border: 1px solid #bababa;
  border-radius: 20px;
}

.tabber-mobile {
  color: #485057;
  background-color: #ffffff73;
}

.label-lateralite {
  position: absolute;
  padding: 0 20px;
  top: 2px;
  z-index: 10;
  margin-bottom: 0;
  transition: transform 125ms ease-in-out, filter 125ms ease-in-out;
}

.label-G {
  left: 0px;
}

.label-D {
  right: 10px;
}

input[type="radio"] {
  display: none;

  // static
  &#lateralitegc~.blob,
  &#lateralitegm~.blob,
  &#lateralitegt~.blob {
    transform-origin: right center;
  }

  &#lateralitedc~.blob,
  &#lateralitedt~.blob,
  &#lateralitedm~.blob {
    transform-origin: left center;
  }

  // animated
  &#lateralitegc:checked,
  &#lateralitegt:checked,
  &#lateralitegm:checked {
    ~.blob {
      background: #fff;
      animation-name: stretchyRev;
    }
  }

  &#lateralitedc:checked,
  &#lateralitedt:checked,
  &#lateralitedm:checked {
    ~.blob {
      background-color: #fff;
      animation-name: stretchy;
    }
  }
}

.blob {
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  position: absolute;
  z-index: 0;
  border-radius: 4rem;
  animation-duration: 0.5s;
  animation-direction: forwards;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  transition: transform 150ms ease;

  &:before,
  &:after {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    background-color: inherit;
    height: 100%;
    width: 50%;
    border-radius: 100%;
    transition: transform 150ms ease;
    animation-name: pulse;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  &:before {
    left: 0;
    animation-delay: 0.15s;
  }

  &:after {
    right: 0;
  }
}

@keyframes stretchy {
  0% {
    transform: translateX(0) scaleX(1);
  }

  100% {
    transform: translateX(100%) scaleX(1);
  }
}

@keyframes stretchyRev {
  0% {
    transform: translateX(100%) scaleX(1);
  }

  100% {
    transform: translateX(0) scaleX(1);
  }
}

.btn-icon {
  background-color: #c6091f;
  color: white;

  &.disabled {
    background-color: #a7a7a7;
  }
}

.calibration-ball-size-btn {
  position: relative;
  padding: 0;
}

.calibration-ball-size-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  transform: translate(-50%, calc(-50% + 2px));
}

</style>
